import React from 'react';
import { Page, Layout } from '@shopify/polaris';

import Orders from '../componets/orders';

const Home = () => {

    return (
        <Page
            title="West n Willow Order Image" separator>
            <Layout>
                <Layout.Section>

                    <Orders url="/orders/all" />

                </Layout.Section>
            </Layout>

        </Page>
    )
}

export default Home;